import { NameHelper, PhoneNumberHelper } from "@swivl-mono/helpers";
import { UserInterface } from "@swivl-mono/types";
import { Button, Input } from "@swivl-mono/ui";
import { CountryCode } from "postcode-validator";
import React, { useEffect } from "react";
import { UsersModel } from "../../../../Models/Users/Users.Model";

import { API } from "@swivl-mono/api-helper";
import { Link, useNavigate } from "react-router-dom";
import LocationsAndGroupsDropdown, { LocationsAndGroupsDropdownType } from "../../../../Components/Dropdowns/LocationsAndGroupsDropdown/LocationsAndGroupsDropdown";

interface Props {
  user: UserInterface
}

export function UserDetailsEditBasicInfoView(props: Props) {
  const { user } = props;
  const [userTemp, setUserTemp] = React.useState<UserInterface>(props.user);
  const [potentialMerge, setPotentialMerge] = React.useState<UserInterface | undefined>();
  const navigate = useNavigate();
  useEffect(() => {
    setUserTemp(props.user);
  }, [props.user]);

  const checkIfPhoneNumberExists = async (phoneNumber: string) => {
    const users = await UsersModel.getUsersByPhoneNumber(phoneNumber);
    let exists = users.length > 0 && users[0].id !== user.id;
    if (exists) {
      return users[0];
    }
  };

  return (
    <div className="">
      <label>NAME</label>
      <Input className="mb-4" placeholder="Name..." value={userTemp.name || ""}
        onChange={(e) => setUserTemp({ ...userTemp, name: e.target.value })}
        onBlur={async () => {
          if (userTemp.name && userTemp.name !== user.name) {
            await UsersModel.updateUser({ id: user.id, name: userTemp.name }, true);
          }
        }}
      />

      <label>PHONE NUMBER</label>
      <Input className="mb-4" placeholder="Phone..." value={userTemp.phoneNumber || ""}
        onChange={(e) => setUserTemp({ ...userTemp, phoneNumber: e.target.value })}
        onBlur={async () => {
          const normalizedPhone = PhoneNumberHelper.normalizePhoneNumber(userTemp.phoneNumber || "", [user.countryCode || CountryCode.US]);
          if (!normalizedPhone) {
            alert("Invalid phone number for the selected country.");
            setUserTemp({ ...userTemp, phoneNumber: user.phoneNumber || "" });
            setPotentialMerge(undefined);

            return;
          }
          if (normalizedPhone !== user.phoneNumber) {
            const exists = await checkIfPhoneNumberExists(normalizedPhone);
            if (exists) {
              setUserTemp({ ...userTemp, phoneNumber: user.phoneNumber || "" });
              setPotentialMerge(exists);
            } else {
              await UsersModel.updateUser({ id: user.id, phoneNumber: normalizedPhone });
              setPotentialMerge(undefined);

            }
          }
        }}
      />

      {potentialMerge && (
        <div className="mb-4 p-2 bg-yellow-100 border border-yellow-400 text-yellow-800 rounded">
          The phone number {potentialMerge.phoneNumber} is already associated with another user: <Link to={"/conversations/user" + potentialMerge.id}>{NameHelper.nameForUser(potentialMerge)}</Link>. Would you like to merge this user into that user?
          <Button className="ml-2" onClickAsync={async () => {
            const mergedUser = await API.Users.mergeUser(user.orgId!, user.id!, potentialMerge.phoneNumber!);
            setPotentialMerge(undefined);

            if (mergedUser) {
              navigate("/conversations/user/" + mergedUser.id);
            }
          }}>Merge Users</Button>
          <Button className="ml-2" onClick={() => setPotentialMerge(undefined)}>Cancel</Button>
        </div>
      )}

      <label>EMAIL</label>
      <Input className="mb-4" placeholder="Email..." value={userTemp.email || ""}
        onChange={(e) => setUserTemp({ ...userTemp, email: e.target.value })}
        onBlur={async () => {
          if (userTemp.email && userTemp.email !== user.email) {
            await UsersModel.updateUser({ id: user.id, email: userTemp.email });
          }
        }}
      />

      <label>POSTAL CODE</label>
      <Input className="mb-4" placeholder="Email..." value={userTemp.postalCode || ""}
        onChange={(e) => setUserTemp({ ...userTemp, postalCode: e.target.value })}
        onBlur={async () => {
          if (userTemp.postalCode && userTemp.postalCode !== user.postalCode) {
            await UsersModel.updateUser({ id: user.id, postalCode: userTemp.postalCode }, true);
          }
        }}
      />

      <label>LOCATION</label>
      <LocationsAndGroupsDropdown
        type={LocationsAndGroupsDropdownType.LOCATIONS}
        deselectLabel={"None"}
        onSelect={(_, locationId) => {
          if (locationId !== user.locationId) {
            UsersModel.updateUser({ id: user.id, locationId: locationId }, true);
          }
        }}
        locationId={userTemp.locationId || undefined}
      />
    </div>
  );
}
